{
  "login": {
    "errors": {
      "invalidCredentials": "Email or password is incorrect."
    },
    "forgotPassword": {
      "back": "Cancel",
      "button": "Forgot password?",
      "submit": "Reset",
      "success": "Password reset email sent! Please check your emails.",
      "title": "Reset your password"
    },
    "labels": {
      "email": "Email",
      "password": "Password"
    },
    "magicLink": {
      "button": "Click here to authenticate yourself",
      "expired": {
        "message": "Enter your email below to receive a new sign-in link.",
        "title": "Your login link has expired"
      },
      "invalid": {
        "message": "Enter your email below to receive a new sign-in link.",
        "title": "This login link is no longer valid"
      },
      "success": "If the email address you entered is valid, we’ll email you a one-time sign-in link in the next few minutes. Please check your inbox —and your spam or junk folder—before requested another link. Thank you."
    },
    "placeholders": {
      "email": "your.email@here.com",
      "password": "",
      "token": "Enter the code generated by your authenticator app"
    },
    "submit": "Login",
    "usernameSubmit": "Next"
  },
  "profile": {
    "2faModal": {
      "confirmation": "Activate 2 factors authentication?",
      "description": "Enabling 2FA will require you to enter a code from your authenticator app every time you log in. Once this is configured you will not be able to access your account without it."
    },
    "labels": {
      "confirm": "Confirmation",
      "email": "Email",
      "name": "Name",
      "password": "Password"
    },
    "passwordHelp": "{{minLength}} characters minimum, with 1 number and 1 uppercase character at least.",
    "passwordsDoNotMatch": "Passwords do not match",
    "placeholders": {
      "confirm": "Confirm new password",
      "name": "Name",
      "password": "New password"
    },
    "submit": {
      "infos": "Save",
      "password": "Save"
    },
    "title": "My Profile",
    "titles": {
      "info": "My informations",
      "password": "My password"
    },
    "tooltips": {
      "email": "Contact support@traceforgood.com if you want to change your email address."
    },
    "updateSuccess": "Profile updated!"
  }
}
